import { DashboardModule } from '@domain-group/suit-theme'

import { formatDate } from '@domain-group/javascript-utils'

import { CampaignInspectionModel } from '@models/types'

import CampaignInspectionListItem from '../CampaignInspectionListItem'

interface CampaignInspectionsDateGroupProps {
  campaignInspections: CampaignInspectionModel[],
  dateString: string,
}

const CampaignInspectionsDateGroup = (props: CampaignInspectionsDateGroupProps) => {
  const { campaignInspections, dateString } = props

  const formattedDate = formatDate(dateString, 'dd/MM/yyyy', 'ccc d LLL yyyy') || undefined

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title={formattedDate}>
      {campaignInspections.map(campaignInspection => (
        <CampaignInspectionListItem
          key={campaignInspection.id}
          campaignInspection={campaignInspection}
        />
      ))}
    </DashboardModule>
  )
}

export default CampaignInspectionsDateGroup
